import type { MouseEventHandler } from 'react';

import { keyframes } from '@emotion/react';
import { Box, Typography } from '@mui/material';

import logo from '@/assets/images/gxLogo.svg';

const logoTextReveal = keyframes({
  from: { opacity: 0, transform: 'translateX(-6px)' },
  to: { opacity: 1, transform: 'translateX(0)' }
});

const goTextBaseSx = {
  userSelect: 'none',
  fontWeight: 500,
  lineHeight: 1,
  ml: 0.5,
  animation: `${logoTextReveal} 0.35s ease-out`
} as const;

type GoLogoProps = {
  size?: number;
  open?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
};

const GoLogo = ({ size = 64, open = true, onClick }: GoLogoProps) => {
  let cursorStyle = 'initial';
  if (onClick) {
    cursorStyle = open ? 'w-resize' : 'e-resize';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: cursorStyle
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-start'
        }}
      >
        <Box
          alt='GX'
          component='img'
          src={logo}
          sx={{
            display: 'flex',
            height: `${size}px`
          }}
        />
      </Box>
      {open && (
        <Typography
          color='primary'
          style={{ fontSize: size }}
          sx={goTextBaseSx}
        >
          Go
        </Typography>
      )}
    </Box>
  );
};

export default GoLogo;
